const staticData = {
  // 人事管理模块-- 退休人员管理 批量导出头
  retireePlainOptions: [
    { label: '序号', value: 'number' },
    { label: '员工编号', value: 'personalNumber' },
    { label: '所在部门', value: 'organizationName' },

    { label: '健康状况', value: 'healthStatus' },
    { label: '民族', value: 'nation' },

    { label: '籍贯', value: 'nativePlace' },
    { label: '政治面貌', value: 'politicalType' },
    { label: '技术职称', value: 'technicalTitle' },

    { label: '军转干部/复原军人', value: 'militaryCadres' },
    { label: '县区', value: 'county' },

    { label: '参加工作时间', value: 'firstWorkTime' },
    { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
    { label: '户口所在地', value: 'registeredResidence' },
    { label: '家庭住址', value: 'homeAddress' },
    { label: '联系方式', value: 'phone' },

    // 退休信息
    { label: '退休前职务', value: 'retirePosition' },
    { label: '退休时间', value: 'retireTime' },
    { label: '退休时身份', value: 'retireIdentity' },
    { label: '退休类别', value: 'retireType' },
    { label: '退休档案号', value: 'retireNumber' },
    { label: '是否社会化管理', value: 'socialManagement' },
    { label: '社会化社区名称', value: 'socialName' },
    { label: '紧急联系人', value: 'emergencyContact' },
    { label: '紧急联系人关系', value: 'emergencyContactRelationship' },
    { label: '紧急联系人电话', value: 'emergencyContactPhone' },

    // 学历信息
    { label: '在职教育学历', value: 'education' },
    { label: '在职教育学位', value: 'academicDegree' },
    { label: '在职教育专业', value: 'major' },
    { label: '在职教育毕业院校', value: 'graduationSchool' },
    { label: '全日制教育学历', value: 'firstEducation' },
    { label: '全日制教育学位', value: 'firstAcademicDegree' },
    { label: '全日制教育专业', value: 'firstMajor' },
    { label: '全日制教育毕业院校', value: 'firstGraduationSchool' }
  ],

  // 人事管理模块-- 退休人员管理 列数据
  retireeColumns: [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80
    },
    {
      title: '员工编号',
      dataIndex: 'personalNumber',
      key: 'personalNumber',
      width: 100,
      align: 'left'
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '所在部门',
      dataIndex: 'organizationName',
      key: 'organizationName',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '退休时身份',
      dataIndex: 'retireIdentity',
      key: 'retireIdentity',
      scopedSlots: { customRender: 'retireIdentity' },
      ellipsis: true,
      align: 'left'
    },
    {
      title: '总工龄',
      dataIndex: 'totalSystemAge',
      key: 'totalSystemAge',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '退休类别',
      dataIndex: 'retireType',
      key: 'retireType',
      scopedSlots: { customRender: 'retireType' },
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'left',
      width: 200
    }
  ],
  // 人事管理模块-- 退休人员管理 列历史数据
  retireeHistoryColumns: [
    {
      title: '时间',
      dataIndex: 'createTime',
      key: 'createTime'
    },

    {
      title: '修改人',
      dataIndex: 'modifyUserName',
      key: 'modifyUserName',
      ellipsis: true
    },

    {
      title: '表单版本',
      dataIndex: 'fromVersion',
      key: 'fromVersion'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'center'
    }
  ],

  // 人事管理模块-- 死亡人员管理 批量导出头
  deathsPlainOptions: [
    { label: '序号', value: 'number' },
    { label: '所在部门', value: 'departmentName' },

    { label: '出生年月', value: 'birthTime' },
    { label: '性别', value: 'sex' },

    { label: '年龄', value: 'age' },
    { label: '民族', value: 'nation' },
    { label: '籍贯', value: 'nativePlace' },

    { label: '政治面貌', value: 'politicalType' },
    { label: '健康状况', value: 'healthStatus' },
    { label: '技术职称', value: 'technicalTitle' },
    { label: '军转干部/复原军人', value: 'militaryCadres' },
    { label: '参加工作时间', value: 'firstWorkTime' },

    { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
    { label: '户口所在地', value: 'registeredResidence' },
    { label: '家庭地址', value: 'homeAddress' },
    { label: '县区', value: 'county' },
    { label: '联系方式', value: 'phone' },

    { label: '全日制教育学历', value: 'firstEducation' },
    { label: '全日制教育学位', value: 'firstAcademicDegree' },
    { label: '全日制教育专业', value: 'firstMajor' },
    { label: '全日制教育毕业院校', value: 'firstGraduationSchool' },

    { label: '在职教育学历', value: 'education' },
    { label: '在职教育学位', value: 'academicDegree' },
    { label: '在职教育专业', value: 'major' },
    { label: '在职教育毕业院校', value: 'graduationSchool' },

    { label: '退休前职务', value: 'retirePosition' },
    { label: '退休时间', value: 'retireTime' },
    { label: '退休时身份', value: 'retireIdentity' },
    { label: '退休类别', value: 'retireType' },
    { label: '死亡时间', value: 'deathTime' },
    { label: '死亡档案号', value: 'deathNumber' },
    { label: '办理人姓名', value: 'handleName' },
    { label: '办理人身份证号', value: 'handleCardNo' },
    { label: '备注', value: 'description' }
  ],
  // 人事管理模块-- 死亡人员管理 列数据
  deathsColumns: [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80
    },
    {
      title: '死亡档案号',
      dataIndex: 'deathNumber',
      key: 'deathNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '年龄',
      dataIndex: 'age',
      key: 'age',
      scopedSlots: { customRender: 'age' },
      ellipsis: true,
      align: 'left'
    },
    {
      title: '家庭住址',
      dataIndex: 'homeAddress',
      key: 'homeAddress',
      ellipsis: true,

      align: 'left'
    },

    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'left',
      width: 200
    }
  ],
  // 人事管理模块-- 死亡人员管理 历史数据
  deathsHistoryColumns: [
    {
      title: '时间',
      dataIndex: 'createTime',
      key: 'createTime'
    },

    {
      title: '修改人',
      dataIndex: 'modifyUserName',
      key: 'modifyUserName',
      ellipsis: true
    },

    {
      title: '表单版本',
      dataIndex: 'fromVersion',
      key: 'fromVersion'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'center'
    }
  ],
  // 人事管理模块-- 人员信息管理 批量导出头 
  // 民福公司
  peopleInformationPlainOptionsMF: [
    { label: '序号', value: 'number' },
    { label: '员工编号', value: 'personalNumber' },
    { label: '所在部门', value: 'organizationName' },
    { label: '行政职务', value: 'mfPosition' },
    { label: '任现职务时间', value: 'positionTime' },
    { label: '任现职务年限', value: 'positionAge' },
    { label: '任现职级时间', value: 'positionLevelTime' },
    { label: '任现职级年限', value: 'positionLevelAge' },
    { label: '首次参加工作时间', value: 'firstWorkTime' },
    { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
    { label: '进入本公司系统时间', value: 'headOfficeSysTime' },
    { label: '本单位工龄', value: 'currentOfficeSysAge' },
    { label: '总工龄', value: 'totalSystemAge' },
    { label: '进入本公司机关时间', value: 'currentOfficeSysTime' },
    { label: '首次签订合同时间', value: 'firstSignContractTime' },
    { label: '首次签订合同类型', value: 'firstContractType' },
    { label: '首次签订合同年限', value: 'firstContractYears' },
    { label: '首次签订到期时间', value: 'firstContractExpirationTime' },
    { label: '续订1合同时间', value: 'secondSignContractTime' },
    { label: '续订1合同类型', value: 'secondContractType' },
    { label: '续订1合同年限', value: 'secondContractYears' },
    { label: '续订1到期时间', value: 'secondContractExpirationTime' },
    { label: '续订2合同时间', value: 'thirdSignContractTime' },
    { label: '续订2合同类型', value: 'thirdContractType' },
    { label: '续订2合同年限', value: 'thirdContractYears' },
    { label: '续订2到期时间', value: 'thirdContractExpirationTime' },
    { label: '性别', value: 'sex' },
    { label: '出生年月', value: 'birthTime' },
    { label: '年龄', value: 'age' },
    { label: '民族', value: 'nation' },
    { label: '健康状况', value: 'healthStatus' },
    { label: '籍贯', value: 'nativePlace' },
    { label: '户口所在地', value: 'registeredResidence' },
    { label: '户口性质', value: 'registeredNature' },
    { label: '出生地', value: 'birthplace' },
    { label: '政治面貌', value: 'politicalType' },
    { label: '入党时间', value: 'joinPartyTime' },
    { label: '技术职称', value: 'technicalTitle' },
    { label: '职称聘任时间', value: 'appointmentTime' },
    { label: '职称获得时间', value: 'acquisitionTime' },
    { label: '在职教育学历', value: 'education' },
    { label: '在职教育学位', value: 'academicDegree' },
    { label: '在职教育专业', value: 'major' },
    { label: '在职教育毕业院校', value: 'graduationSchool' },
    { label: '全日制教育学历', value: 'firstEducation' },
    { label: '全日制教育学位', value: 'firstAcademicDegree' },
    { label: '全日制教育专业', value: 'firstMajor' },
    { label: '全日制教育毕业院校', value: 'firstGraduationSchool' },
    { label: '家庭地址', value: 'homeAddress' },
    { label: '联系电话', value: 'phone' },
    { label: '减员日期', value: 'attrtionTiem' },
    { label: '减员备注', value: 'attrtionDes' },
    { label: '减员原因', value: 'attritionReason' },
    { label: '在职人员档案号', value: 'archiveseNumber' },
    { label: '紧急联系人', value: 'emergencyContact' },
    { label: '紧急联系人关系', value: 'emergencyContactRelationship' },
    { label: '紧急联系人电话', value: 'emergencyContactPhone' },
  ],
  // 非民福公司
  peopleInformationPlainOptions: [
    { label: '序号', value: 'number' },
    { label: '员工编号', value: 'personalNumber' },
    { label: '所在部门', value: 'organizationName' },

    { label: '行政职务', value: 'position' },
    { label: '任现职务时间', value: 'positionTime' },
    { label: '任现职务年限', value: 'positionAge' },

    { label: '职级', value: 'positionLevel' },
    { label: '任现职级时间', value: 'positionLevelTime' },
    { label: '任现职级年限', value: 'positionLevelAge' },

    { label: '首次参加工作时间', value: 'firstWorkTime' },
    { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
    { label: '进入总公司系统时间', value: 'headOfficeSysTime' },
    { label: '本单位工龄', value: 'currentOfficeSysAge' },
    { label: '总工龄', value: 'totalSystemAge' },

    { label: '进入本单位时间', value: 'currentOfficeSysTime' },
    { label: '首次签订合同时间', value: 'firstSignContractTime' },
    { label: '首次签订合同类型', value: 'firstContractType' },
    { label: '首次签订合同年限', value: 'firstContractYears' },
    { label: '首次签订到期时间', value: 'firstContractExpirationTime' },

    { label: '续订1合同时间', value: 'secondSignContractTime' },
    { label: '续订1合同类型', value: 'secondContractType' },
    { label: '续订1合同年限', value: 'secondContractYears' },
    { label: '续订1到期时间', value: 'secondContractExpirationTime' },

    { label: '续订2合同时间', value: 'thirdSignContractTime' },
    { label: '续订2合同类型', value: 'thirdContractType' },
    { label: '续订2合同年限', value: 'thirdContractYears' },
    { label: '续订2到期时间', value: 'thirdContractExpirationTime' },

    { label: '性别', value: 'sex' },
    { label: '出生年月', value: 'birthTime' },
    { label: '年龄', value: 'age' },
    { label: '民族', value: 'nation' },
    { label: '健康状况', value: 'healthStatus' },
    { label: '籍贯', value: 'nativePlace' },
    { label: '户口所在地', value: 'registeredResidence' },
    { label: '户口性质', value: 'registeredNature' },
    { label: '出生地', value: 'birthplace' },
    { label: '政治面貌', value: 'politicalType' },
    { label: '入党时间', value: 'joinPartyTime' },
    { label: '技术职称', value: 'technicalTitle' },
    { label: '职称聘任时间', value: 'appointmentTime' },
    { label: '职称获得时间', value: 'acquisitionTime' },
    { label: '在职教育学历', value: 'education' },
    { label: '在职教育学位', value: 'academicDegree' },
    { label: '在职教育专业', value: 'major' },
    { label: '在职教育毕业院校', value: 'graduationSchool' },
    { label: '全日制教育学历', value: 'firstEducation' },
    { label: '全日制教育学位', value: 'firstAcademicDegree' },
    { label: '全日制教育专业', value: 'firstMajor' },
    { label: '全日制教育毕业院校', value: 'firstGraduationSchool' },
    { label: '家庭地址', value: 'homeAddress' },
    { label: '联系电话', value: 'phone' },
    { label: '减员日期', value: 'attrtionTiem' },
    { label: '减员备注', value: 'attrtionDes' },
    { label: '减员原因', value: 'attritionReason' },
    { label: '在职人员档案号', value: 'archiveseNumber' },
  ],

  // 人事管理模块-- 人员信息管理  列表列数据
  // 民福公司
  rosterColumnsMF: [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80
    },
    {
      title: '员工编号',
      dataIndex: 'personalNumber',
      key: 'personalNumber',
      align: 'left'
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '所在部门',
      dataIndex: 'organizationName',
      key: 'organizationName',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '行政职务',
      dataIndex: 'position',
      key: 'position',
      scopedSlots: { customRender: 'position' },
      ellipsis: true,
      align: 'left'
    },
    {
      title: '总工龄',
      dataIndex: 'totalSystemAge',
      key: 'totalSystemAge',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '进入本公司机关时间',
      dataIndex: 'currentOfficeSysTime',
      key: 'currentOfficeSysTime',
      ellipsis: true,
      align: 'left'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'left',
      width: 200
    }
  ],
  // 非民福公司
  rosterColumns: [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80
    },
    {
      title: '员工编号',
      dataIndex: 'personalNumber',
      key: 'personalNumber',
      align: 'left'
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '所在部门',
      dataIndex: 'organizationName',
      key: 'organizationName',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '行政职务',
      dataIndex: 'position',
      key: 'position',
      scopedSlots: { customRender: 'position' },
      ellipsis: true,
      align: 'left'
    },
    {
      title: '总工龄',
      dataIndex: 'totalSystemAge',
      key: 'totalSystemAge',
      ellipsis: true,
      width: 100,
      align: 'left'
    },
    {
      title: '进入本单位时间',
      dataIndex: 'currentOfficeSysTime',
      key: 'currentOfficeSysTime',
      ellipsis: true,
      align: 'left'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'left',
      width: 200
    }
  ],

  // 人事管理模块-- 人员信息管理  历史数据 列表列数据
  rosterHistoryColumns: [
    {
      title: '时间',
      dataIndex: 'createTime',
      key: 'createTime'
    },

    {
      title: '修改人',
      dataIndex: 'modifyUserName',
      key: 'modifyUserName',
      ellipsis: true
    },

    {
      title: '表单版本',
      dataIndex: 'fromVersion',
      key: 'fromVersion'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'center'
    }
  ],

  // 退休人员模块-- 退休人员信息 批量导出头
  retireePlainOptions1: [
    { label: '序号', value: 'number' },
    { label: '员工编号', value: 'personalNumber' },
    { label: '性别', value: 'sex' },
    { label: '出生年月', value: 'birthTime' },
    { label: '年龄', value: 'age' },
    { label: '民族', value: 'nation' },
    { label: '籍贯', value: 'nativePlace' },
    { label: '出生地', value: 'birthplace' },
    { label: '政治面貌', value: 'politicalType' },
    { label: '入党时间', value: 'joinPartyTime' },
    { label: '户口所在地', value: 'registeredResidence' },
    { label: '户口性质', value: 'registeredNature' },
    { label: '健康状况', value: 'healthStatus' },
    { label: '联系电话', value: 'phone' },
    { label: '家庭地址', value: 'homeAddress' },
    { label: '所在部门', value: 'organizationName' },
    { label: '行政职务', value: 'position' },
    { label: '任现职务时间', value: 'positionTime' },
    { label: '任现职务年限', value: 'positionAge' },
    { label: '职级', value: 'positionLevel' },
    { label: '任现职级时间', value: 'positionLevelTime' },
    { label: '任现职级年限', value: 'positionLevelAge' },
    { label: '技术职称', value: 'technicalTitle' },
    { label: '职称聘任时间', value: 'appointmentTime' },
    { label: '职称获得时间', value: 'acquisitionTime' },
    { label: '首次参加工作时间', value: 'firstWorkTime' },
    { label: '总工龄', value: 'totalSystemAge' },
    { label: '进入本公司机关时间', value: 'currentOfficeSysTime' },
    { label: '本单位工龄', value: 'currentOfficeSysAge' },
    { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
    { label: '进入本公司系统时间', value: 'headOfficeSysTime' }
  ],

  // 退休人员模块-- 退休人员信息 批量导出头
  retireeColumns1: [
    {
      title: '序号',
      dataIndex: 'number',
      key: 'number',
      width: 80,
      align: 'center'
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'left',
      ellipsis: true
    },
    {
      title: '所在部门',
      dataIndex: 'organizationName',
      key: 'organizationName',
      align: 'left',
      ellipsis: true
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      align: 'left',
      ellipsis: true
    },
    {
      title: '行政职务',
      dataIndex: 'position',
      key: 'position',
      scopedSlots: { customRender: 'position' },
      ellipsis: true,
      align: 'left'
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      scopedSlots: { customRender: 'sex' },
      align: 'left',
      ellipsis: true
    },
    {
      title: '政治面貌',
      dataIndex: 'politicalType',
      key: 'politicalType',
      scopedSlots: { customRender: 'politicalType' },
      align: 'left',
      ellipsis: true
    },
    {
      title: '年龄',
      dataIndex: 'age',
      key: 'age',
      align: 'left',
      ellipsis: true
    }
  ],

  // 银行卡管理 -- 列数据
  bankCardColumns: [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80
    },
    {
      title: '姓名',
      dataIndex: 'fullName',
      key: 'fullName',
      ellipsis: true,
      // width: 100,
      align: 'left'
    },
    {
      title: '身份证号',
      dataIndex: 'idCardNumber',
      key: 'idCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '银行卡号',
      dataIndex: 'bankCardNumber',
      key: 'bankCardNumber',
      ellipsis: true,
      align: 'left'
    },
    {
      title: '开户行名称',
      dataIndex: 'bank',
      key: 'bank',
      ellipsis: true,
      align: 'left'
    },
    {
      key: 'operation',
      scopedSlots: { customRender: 'action' },
      title: '操作',
      align: 'left',
      width: 200
    }
  ]
}

export default staticData


// WEBPACK FOOTER //
// ./src/views/PersonnelManagement/staticData/staticData.js